<!--
 * @Author: vince
 * @Date: 2021-08-24 18:10:10
 * @LastEditors: vince
 * @LastEditTime: 2021-08-30 10:53:25
 * @Description: 
-->
<template>
	<div class="editor" ref="editor"></div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
import { conf } from "@/config";
import { getData } from "@/http/fetch.js";
export default {
	model: {
		prop: "value",
		event: "change"
	},
	props: {
		value: {
			type: String
		}
	},
	data() {
		return {
			editor: null,
			qnData: {
				token: "",
				key: ""
			},
			domainUrl: ""
		};
	},
	mounted() {
		const editor = new wangEditor(this.$refs.editor);
		let _this = this;
		// 配置 onchange 回调函数，将数据同步到 vue 中
		editor.config.onchange = newHtml => {
			_this.$emit("change", newHtml);
		};
		editor.config.placeholder = '';
		editor.config.height = 400;
		editor.config.customUploadImg = function(resultFiles, insertImgFn) {
			// resultFiles 是 input 中选中的文件列表
			// insertImgFn 是获取图片 url 后，插入到编辑器的方法

			// _this.$axios
			// 	.post("/file/uploadFiles", formdata, {
			// 		headers: { "Content-Type": "multipart/form-data" } //设置请求头请求格式为JSON
			// 	})
			// 	.then(res => {
			// 		res.data.forEach(f => {
			// 			insertImgFn(f.attachUrl);
			// 		});
			// 	})
			// 	.catch(e => {
			// 		console.error(e);
			// 	});

			// 上传图片，返回结果，将图片插入到编辑器中
			getData("/file/getQiNiuAccessToken").then(tRes => {
				console.log("--tRes", tRes);		
				resultFiles.forEach(f => {
					let formdata = new FormData();
					console.log("f", f);
					formdata.append("file", f);
					formdata.append("token", tRes.accessToken);
					formdata.append(
						"key",
						new Date().getTime() +
							"." +
							f.name.split(".")[f.name.split(".").length - 1]
					);
					_this.$axios
						.post(conf.uploadAction, formdata, {
							headers: { "Content-Type": "multipart/form-data" } //设置请求头请求格式为JSON
						})
						.then(res => {
							console.log("res", res);
							formdata = null;
							insertImgFn(tRes.domainUrl + res.key);
						})
						.catch(e => {
							console.error(e);
						});
				});
			});
		};

		// 创建编辑器
		editor.create();
		this.editor = editor;
		if (this.value.length > 0) {
			setTimeout(() => {
				this.editor.txt.html(this.value);
			}, 1000);
		}
	},
	watch: {
		value() {
			this.editor.txt.html(this.value);
		}
	},
	methods: {
		uploadImage(files) {},
		getHtml() {
			// 通过代码获取编辑器内容
			return this.editor.txt.html();
		}
	},
	beforeDestroy() {
		// 调用销毁 API 对当前编辑器实例进行销毁
		this.editor.destroy();
		this.editor = null;
	}
};
</script>

<style lang="scss">
</style>
